import React from "react";

import { PeopleCard } from "@caelor/ui";
import { useTranslation } from "react-i18next";

import {
  StateCardsContainer,
  StateContainer,
  StateContentContainer,
  StateParagraph,
  StateHeaderContainer,
  StateHeading,
  StateHeadingBrand,
  StateFooterContainer,
  StateButton,
  StateLink,
} from "./style";
import { MACRO_DATA } from "./defaults";
import { useStyleguideColors } from "../../hooks/use-styleguide-colors";
import { useOpticsStore } from "../../stores/use-optics-store";

const CosmosNotInstalled = ({ macro }) => {
  const WIDGET = MACRO_DATA[macro];

  const { t } = useTranslation();

  const { styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));
  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  return (
    <StateContainer>
      <StateContentContainer>
        <StateHeaderContainer>
          <StateHeading>
            <StateHeadingBrand>{WIDGET.name}</StateHeadingBrand> -{" "}
            {t("powered-by-cosmos")}
          </StateHeading>
          <StateParagraph>{WIDGET.description}</StateParagraph>
        </StateHeaderContainer>
        <StateCardsContainer>
          {WIDGET.people.map((person) => (
            <PeopleCard
              avatarUrl={person.avatarUrl}
              name={person.name}
              subtitle={person.subtitle}
              label={person.label}
              emoji={person?.emoji}
              accentColor={styleguideColors?.accent}
            />
          ))}
        </StateCardsContainer>
        <StateFooterContainer>
          <StateParagraph style={{ fontSize: "16px" }}>
            {t("module-powered-by-cosmos")}
          </StateParagraph>
          <StateButton
            onClick={() =>
              window.open(
                "https://marketplace.atlassian.com/apps/1230540",
                "_blank"
              )
            }
          >
            {t("get-cosmos-it-is-free")}
          </StateButton>
          <StateLink
            onClick={() =>
              window.open(
                "https://caelor-apps.atlassian.net/wiki/x/BRP6",
                "_blank"
              )
            }
          >
            {t("learn-more-about-cosmos")}
          </StateLink>
        </StateFooterContainer>
      </StateContentContainer>
    </StateContainer>
  );
};

export default CosmosNotInstalled;
